import { useEffect, useState } from 'react';
import { Button, Select, Space } from 'antd';
import CustomerService from "services/customer"
import { formatCurrency } from "utils/number"
import { UserAddOutlined, SolutionOutlined } from "@ant-design/icons"
import CustomerInfoEdit from "components/customer/CustomerInfoEdit"
import CustomerInfo from 'components/customer/InfoModal2';
const service = new CustomerService();
const CustomerPicker = (props) => {
    const [customers, setCustomers] = useState([]);
    const [showAddCustomer, setShowAddCustomer] = useState(false)
    const [showCustomerInfo, setShowCustomerInfo] = useState(false)

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        var lst = await service.list({});
        setCustomers(lst);
    }


    const onChange = (e) => {

        props.onChange(e);
        var cus = customers.find(x => x.id == e);
        if (cus) {
            props.onCustomerChange(cus);
        }
    }

    const onCutomerSaved = async (cus) => {
        await loadData();
        props.onChange(cus.id);
        props.onCustomerChange(cus);

    }

    return (
        <>
            <div style={{ display: "flex", gap: 8 }}>


                <div style={{ flexGrow: 1 }}>


                    <Select
                        {...props}
                        showSearch
                        placeholder="Chọn khách hàng"
                        onChange={onChange}
                        filterOption={(input, option) => {

                            var _a;
                            return (
                                (_a = option === null || option === void 0 ? void 0 : option.search_text) !== null &&
                                    _a !== void 0
                                    ? _a
                                    : ''
                            )
                                .toLowerCase()
                                .includes(input.toLowerCase());
                        }}
                        options={customers.map(x => ({ label: `${x.phone} ${x.full_name}`, value: x.id, search_text: x.search_text }))}
                        notFoundContent={<div>
                            Không tìm thấy khách hàng
                            Bạn có thể tạo mới khách hàng
                        </div>}
                    />
                </div>

                <div >
                    <Space>
                        {props.value &&
                            <Button onClick={e => setShowCustomerInfo(true)}><SolutionOutlined /></Button>
                        }
                        <Button onClick={e => setShowAddCustomer(true)}><UserAddOutlined /></Button>


                    </Space>


                </div>

            </div>
            <CustomerInfoEdit open={showAddCustomer} onClose={e => setShowAddCustomer(false)} onSave={onCutomerSaved}></CustomerInfoEdit>
            <CustomerInfo id={props.value} open={showCustomerInfo} onClose={e => setShowCustomerInfo(false)}></CustomerInfo>
        </>
    )
}
export default CustomerPicker;